export const stopSearchBarTestIds = {
  electricityFilter: 'StopSearchBar::electricityFilter',
  elyInput: 'StopSearchBar::elyInput',
  infoSpotsFilter: 'StopSearchBar::infoSpotsFilter',
  municipalitiesFilter: 'StopSearchBar::municipalitiesFilter',
  observationDateInput: 'StopSearchBar::observationDateInput',
  searchForDropdown: 'StopSearchBar::SearchForDropdown',
  shelterFilter: 'StopSearchBar::shelterFilter',
  stopStateFilter: 'StopSearchBar::stopStateFilter',
  stopOwnerFilter: 'StopSearchBar::stopOwnerFilter',
  prefix: 'StopSearchBar',
};
